// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__855Fc","left":"styles_left__3_J2l"};